import ReactJs from 'react';
import {makeStyles,Button } from "@material-ui/core";
import emailjs from "emailjs-com";
import { Icon, InlineIcon } from '@iconify/react';
import linkedinIcon from '@iconify-icons/mdi/linkedin';


const Contact = ({title,dark,id}) => {
    const classes = useStyles();
    

    

    function sendEmail(i){
      i.preventDefault();

    emailjs.sendForm('service_oa87i9o', 'template_3rvn7vd', i.target, 'user_2LZgnEaR7qN8npE6UXxDO')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      i.target.reset();
    }

    return (
      <div className={classes.root} id={id}>
        <div className={classes.subContainer}>
       
          <form onSubmit={sendEmail} className={classes.formContainer} >
          <div className={classes.title}>Contact</div>
           <div className={classes.userdetails}>
            <div className={classes.inputbox}>
            
            <div className={classes.links}> 
            <Button  className={classes.icon} >
            <span className={classes.textLink} >Linkedin</span> 
            <a href={"https://www.linkedin.com/in/diego-ignacio-ya%C3%B1ez-gonzalez-7634331b8/"} >
            
            <Icon className={classes.linkedin} icon={linkedinIcon} />
              </a> 
            </Button>
           </div>
             <span >Full Name</span>  
              <input 
              className={classes.input}
              name="from_name" 
              type="text" 
              placeholder="Enter your name" 
              required
              minLength="4"
              maxLength="20"
              >
              </input>
           </div>

           <div className={classes.inputbox}>
             <span >Email</span>  
              <input 
              className={classes.input}
              name="email" 
              type="email" 
              placeholder="Enter your email" 
              required ></input>
           </div>

           <div className={classes.inputbox}>
             <span >Message</span>  
              <textarea 
              className={classes.inputTarea}
              name="message"
              type="text" 
               
              required
              minLength="4"
              maxLength="100"
              resize="none"
              ></textarea>
           </div>

           <div className={classes.button}>
             
              <input
              className={classes.buttonInput}
              type="submit" 
              value="Send Message" 
              required>
              </input>
             
           </div>
          
          </div>
          </form> 
          </div>
         

      </div>

    )
}
const useStyles = makeStyles((theme) => ({ 
  
    root: {
       
       display:"flex",
       height:"100%",
       justifyContent:"center",
       alignItems:"center",
       background:'#d4d5d6',
       [theme.breakpoints.down("sm")]:{
        width:"100%",
        
        

    }
    },
    subContainer:{
      
       
       maxWidth:"100%",
       width:"700px",
       background:"#d4d5d6",
       padding:"25px 38px",
       borderRadius:"5px",
       [theme.breakpoints.down("sm")]:{
       width:"50%"
        

    }
    },
    title:{
      color:"#0c82ad",
      
       fontSize:"40px",
       fontWeight:"bold",
       position:"relative"
    },
   
    inputbox:{
      
      margin:"20px 0 12px 0",
      display:"block",
      color:"white",
      
    },
    input:{
      
      width:"100%",
      resize:"none",
      height:"30px",
      outline:"none",
      borderRadius:"5px",
      border:"1px solid #ccc",
      paddinLeft:"15px",
      fontSize:"16px",
      borderBottomWidth:"2px",
      transition:"all 0.3s ease",
      background:"white"
    },
    inputTarea:{
      width:"100%",
      resize:"none",
      height:"100px",
      outline:"none",
      borderRadius:"5px",
      border:"1px solid #ccc",
      paddinLeft:"15px",
      fontSize:"16px",
      borderBottomWidth:"2px",
      transition:"all 0.3s ease",
      background:"white"
      
      
    },
    button:{
      color:"red",
      height:"45px",
      margin:"15px 0"
    },
    buttonInput:{
      height:"45px",
      width:"100%",
      outline:"none",
      color:"white",
      backgroundColor:"#87e8c8",
      border:"none",
      fontSize:"18px",
      fontWeight:"500",
      letterSpacing:"1px",
      borderRadius:"5px",
      "&:hover":{
        background:'linear-gradient(-135deg, #333, #333)'
    } 
    },
    links:{
      display:"flex",
      justifyContent:"center",
      
      
    },
    icon:{
      marginBottom:"20px",
     fontSize:"3rem",
     border:"1px solid #ccc",
     lineHeight:"40px",
     color:"#fff",
     cursor:"pointer",
     transition:".5s",
     "&:hover":{
       background:"#87e8c8",
       transform: `translateY(-7px)`
       
     }
     
    },
    textLink:{
      
      position:"relative",
      display:"flex",
      fontSize:"10px",
      justifyContent:"center",
    },
    linkedin:{
      color:"white",
      
    },
    formContainer:{
      
      marginBottom:theme.spacing(25)
    }
  }))

   

export default Contact;
